import React from "react";
import MainLayout from "../components/Layout/MainLayout";
import TimezoneSettings from "../components/Settings/TimezoneSettings";

const SettingsPage = () => {
    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold text-[#CCCCCC] mb-6">
                Настройки системы
            </h1>
            <div className="grid md:grid-cols-2 gap-6">
                <TimezoneSettings />
            </div>
        </div>
    );
};

export default SettingsPage;
